<template>
  <div class="home">
    <el-row :gutter="5" class="ibanner">
      <el-col :span="6">
        <router-link :to="'/detail' + banner[0].id + '?type=1'">
          <img :src="banner[0].image" :alt="banner[0].title">
        </router-link>

        <router-link :to="'/detail' + banner[3].id + '?type=1'" class="mt5" style="display:block;">
          <img :src="banner[3].image" height="249" width="100%" :alt="banner[3].title">
        </router-link>
      </el-col>
      <el-col :span="9">
        <router-link :to="'/detail' + banner[1].id + '?type=1'">
          <img :src="banner[1].image" height="386.89" width="100%" :alt="banner[1].title">
        </router-link>
      </el-col>
      <el-col :span="9">
        <router-link :to="'/detail' + banner[2].id + '?type=1'">
          <img :src="banner[2].image" :alt="banner[2].title">
        </router-link>

        <el-row :gutter="5" class="mt5">
          <el-col :span="12">
            <router-link :to="'/detail' + banner[4].id + '?type=1'">
              <img :src="banner[4].image" height="182" width="100%" :alt="banner[4].title">
            </router-link>
          </el-col>
          <el-col :span="12">
            <router-link :to="'/detail' + banner[5].id + '?type=1'">
              <img :src="banner[5].image" height="182" width="100%" :alt="banner[5].title">
            </router-link>
          </el-col>
        </el-row>
      </el-col>
    </el-row>


    <el-row :gutter="20" class="mt20">
      <el-col :span="16">
        <el-card shadow="never" :body-style="{padding: '15px'}" style="height: 417px">
          <template slot="header">
            <span class="theme size16">资讯公告</span>
          </template>

          <el-row :gutter="20">
            <el-col :span="11" style="width: 43.23333%;">
              <!-- <router-link :to="'/detail' + notice.id"> -->
                <img :src="notice.image" alt="">
              <!-- </router-link> -->
            </el-col>

            <el-col :span="13">
              <list />
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">最新开服</span>
          </template>

          <hot-list />
        </el-card>
      </el-col>

      <el-col :span="24" class="mt10">
        <el-card shadow="never">
          <template slot="header"><span class="theme size16">游戏视频</span></template>

          <el-row :gutter="20">
            <el-col :span="6" v-for="item in videoList" :key="item.id">
              <router-link :to="item.id + '?type=1'">
                <img :src="item.image" :alt="item.title">
                <div class="video-title ellipsis">{{ item.title }}</div>
              </router-link>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Home',

  data() {
    return {
      banner: this.$datas.bannerList,
      videoList: this.$datas.videoList,
      notice: this.$datas.notice,
      remList: this.$datas.remList,
    }
  },
}
</script>

<style lang="scss" scoped>
.ibanner {
  a {
    display: block;
    overflow: hidden;
    /* &:hover {
      transition: all .5s;
      transform: scale(1.05, 1.05);
    } */
    &:hover img {
      transition: all .5s;
      transform: scale(1.05, 1.05);
    }
  }
}
.video-title {
  margin-top: 4px;
}
</style>
